module.exports = __webpack_public_path__ + "img/collection-weddingRingsWhitegold.2c4e4e2.webp";